"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _Card = _interopRequireDefault(require("@mui/material/Card"));
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _CardStyles = require("./CardStyles");
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _classnames = _interopRequireDefault(require("classnames"));
var _string = require("../../utils/type-checks/string");
var _useElementSize = require("../../utils/hooks/useElementSize");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
require("./../../scss/index.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const merge = require("deepmerge"),
  CardButton = props => {
    const {
        customClassNames,
        path,
        label,
        onClick,
        buttonTestId,
        variant = "ctalinkWithArrow",
        url
      } = props,
      buttonClasses = (0, _classnames.default)({
        "IconCard__button": true,
        [`${customClassNames}`]: (0, _string.isStringOfLength)(customClassNames)
      });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _string.isStringOfLength)(label) && (0, _string.isStringOfLength)(path) && /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: buttonClasses,
      component: _reactRouterDom.Link,
      "data-testid": buttonTestId,
      onClick: onClick,
      to: path,
      variant: variant
    }, label), (0, _string.isStringOfLength)(label) && (0, _string.isStringOfLength)(url) && !(0, _string.isStringOfLength)(path) && /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: buttonClasses,
      component: "a",
      "data-testid": buttonTestId,
      onClick: onClick,
      href: url,
      target: "_blank",
      variant: variant
    }, label));
  };

/**
 * Card with image icon, with row and column variant behavior
 *
 * @visibleName Icon Card
 * @author Tanner Williams
*/
const IconCard = props => {
  const {
      button,
      fragmentId,
      children,
      className,
      customContainerSx = {},
      customContentSx,
      customInnerContentSx,
      customTheme = {},
      id,
      image = {
        alt: "",
        src: "",
        style: {}
      },
      text,
      title,
      variant = "icon",
      // Test ID's
      testId,
      contentTestId,
      innerTestId,
      textTestId,
      titleTestId,
      defaultIsThinCard = false,
      thinCardWidth = 350
    } = props,
    compiledClassnames = (0, _classnames.default)({
      "iconCard": true,
      [`${className}`]: className
    }),
    theme = merge((0, _styles.useTheme)(), customTheme),
    [iconCardRef, {
      width
    }] = (0, _useElementSize.useElementSize)(),
    {
      src,
      alt,
      style
    } = image;
  const variantContainerSx = variant === "column" ? {
    justifyContent: "center",
    ".iconCard__content": {
      flexDirection: "column",
      padding: "3rem 3rem",
      textAlign: "center",
      "img": {
        maxWidth: "30rem",
        margin: "0 auto 2rem",
        paddingRight: {
          xs: 0,
          sm: 0
        },
        width: "auto"
      }
    },
    ".iconCard__InnerContent": {
      fontSize: "2rem",
      alignItems: "center !important",
      "a": {
        marginTop: "3rem"
      }
    }
  } : {};
  const [isThinCard, setIsThinCard] = (0, _react.useState)(defaultIsThinCard);
  (0, _react.useLayoutEffect)(() => {
    if (width < thinCardWidth) {
      setIsThinCard(true);
    } else {
      setIsThinCard(false);
    }
  }, [width, thinCardWidth]);
  const containerSx = merge.all([(0, _CardStyles.DefaultIconCardSx)(theme, isThinCard), variantContainerSx, customContainerSx]);
  return /*#__PURE__*/_react.default.createElement(_Card.default, {
    className: compiledClassnames,
    "data-testid": testId,
    id: id,
    sx: containerSx,
    ref: iconCardRef
  }, /*#__PURE__*/_react.default.createElement(_CardContent.default, {
    className: "iconCard__content",
    "data-testid": contentTestId,
    sx: customContentSx
  }, (0, _string.isStringOfLength)(src) && (0, _string.isStringOfLength)(alt) && /*#__PURE__*/_react.default.createElement(_material.CardMedia, {
    component: "img",
    sx: style,
    image: src,
    alt: alt
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "iconCard__InnerContent",
    "data-testid": innerTestId,
    sx: customInnerContentSx
  }, title && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    "data-testid": titleTestId,
    component: "h4",
    className: "heading--isCardHeading"
  }, title), text && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    "data-testid": textTestId
  }, text), fragmentId && /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: fragmentId
  }), children, button?.label && /*#__PURE__*/_react.default.createElement(CardButton, button))));
};

// Define propTypes;
IconCard.propTypes = {
  /** Object describing button properties */
  button: _propTypes.default.shape({
    /** Button label */
    label: _propTypes.default.string,
    /** Path, if using internal React Route */
    path: _propTypes.default.string,
    /** External URL, if not using a path */
    url: _propTypes.default.string,
    /** Button variant */
    variant: _propTypes.default.string
  }),
  /** Child content nodes, appears after content fragment */
  children: _propTypes.default.any,
  /** Custom style object for component (Default Value: {}) */
  customContainerSx: _propTypes.default.object,
  /** Custom style object for content section (including image and text content) */
  customContentSx: _propTypes.default.object,
  /** Custom style object for interior text and button content */
  customInnerContentSx: _propTypes.default.object,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Content Fragment ID, inserted after text property */
  fragmentId: _propTypes.default.string,
  /** Optional ID value */
  id: _propTypes.default.string,
  /** Object describing icon image properties */
  image: _propTypes.default.shape({
    /** Alt. Description of image (Default Value: "") */
    alt: _propTypes.default.string,
    /** URL to image (Default Value: "") */
    src: _propTypes.default.string,
    /** Custom style object for image (Default Value: {}) */
    style: _propTypes.default.object
  }),
  /** Content text, inserted after heading */
  text: _propTypes.default.string,
  /** Heading title text */
  title: _propTypes.default.string,
  /** Card variant controlling icon positioning (Default Value: "icon") */
  variant: _propTypes.default.oneOf(["icon", "column"]),
  /** Boolean value to trigger trigger card as thin (default Value: false) */
  defaultIsThinCard: _propTypes.default.bool,
  /**Thin Card width (Default Value: 350) */
  thinCardWidth: _propTypes.default.number
};
CardButton.propTypes = {
  buttonTestId: _propTypes.default.string,
  customClassNames: _propTypes.default.string,
  label: _propTypes.default.string,
  onClick: _propTypes.default.func,
  path: _propTypes.default.string,
  variant: _propTypes.default.string,
  url: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = IconCard;